import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/node_modules/react-bootstrap/esm/Button.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/node_modules/react-bootstrap/esm/Modal.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/node_modules/react-loading-skeleton/dist/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/react-loading-skeleton/dist/skeleton.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/src/components/common/Breadcrumb.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/src/components/completejewel/Review.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/src/components/shoppingprogress/ShoppingProgress.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/src/style/route-listing-detail.scss");
